import React from "react";

class TextareaField extends React.Component{
    render(){
        const that = this
        return (
            <div class="js-form-field__wrapper">
                <div class="js-form-field__text">
                    <textarea 
                        name={this.props.name}
                        id={this.props.id}
                        
                        // defaultValue={this.props.value}
                        placeholder={this.props.placeholder}
                        required={this.props.required}
                    >
                    </textarea>
                </div>
            </div>
        )
    }
}

export default TextareaField